import {createFeatureSelector, createSelector} from '@ngrx/store';
import {AuthState} from '../reducers/auth.reducer';
import {Features} from '../../Features';
import {selectUser, selectUserLoading} from '../../user/selectors/user.selectors';
import {selectCompanyLoading, selectMyCompany} from '../../company/selectors/company.selectors';
import {Roles} from '../../../enum/roles';
import {Permissions} from '../../../enum/permissions';

export const selectAuthFeatureState = createFeatureSelector<AuthState>(Features.AUTH);

export const selectAuthenticated = createSelector(
  selectAuthFeatureState,
  (state: AuthState) => state.isAuthenticated
);

export const selectUserRoles = createSelector(
  selectAuthFeatureState,
  (state: AuthState) => state.roles
);
export const selectUserPermissions = createSelector(
  selectAuthFeatureState,
  (state: AuthState) => state.permissions
);
export const selectAllowedToCreateOffer = createSelector(
  selectAuthFeatureState,
  (state: AuthState) => state.permissions.includes(Permissions.offer_create)
);
export const selectAuthRelatedLoading = createSelector(
  selectAuthenticated,
  selectUserRoles,
  selectUserLoading,
  selectCompanyLoading,
  (isAuthenticated: boolean, roles: Roles[], userLoading: boolean, companyLoading: boolean) => {
    return {
      isAuthenticated: isAuthenticated,
      roles: roles,
      userLoading: userLoading,
      companyLoading: companyLoading,
    };
  }
);

export const selectForAuthGuardRouting = createSelector(
  selectUserRoles,
  selectUser,
  selectMyCompany,
  (roles, userCreated, companyCreated) => {
    return {
      roles: roles,
      userCreated: userCreated,
      companyCreated: companyCreated,
    };
  }
);
